export const HUD_FONT = 'RetroMario';

const HUD_FONT_SIZES = [26, 36, 52, 88] as const;

/** Ensure RetroMario is loaded before Phaser canvas text is measured. */
export async function preloadHudFont(): Promise<void> {
  if (!document.fonts?.load) return;

  await Promise.all(HUD_FONT_SIZES.map((size) => document.fonts.load(`${size}px ${HUD_FONT}`)));
  await document.fonts.ready;
}
